// we simulate the shift status update API to return the same response as the previous record, but with the new status and location, so that the UI can update immediately without waiting for the next fetch of user data. This is a bit hacky but it allows us to have a more responsive UI without having to implement a full state management solution for the user data in the mock environment.



export function getYesterdayDateISO() {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    date.setUTCHours(0, 0, 0, 0);
    return date.toISOString();
}

//compatible for user/time endpointws
let simulatedResponses = {
    "time-in": {
        "_id": "69e55fff7b564a00699d7993",
        "record": [
            {
                "dateTime": "2026-04-20T07:06:39.539Z",
                "status": "time-in",
                "month": 4,
                "day": 20,
                "year": 2026,
                "time": 1776639999583,
                "date": "2026-04-20T00:00:00.000Z",
                "location": {
                    "latitude": 14.8779002,
                    "longitude": 121.0476598
                },
                "address": "N/A",
                "ip": "Test"
            }
        ],
        "uid": "61442a17a6566a001623bf20",
        "date": new Date().toISOString(),
        "status": "time-in",
        "createdAt": "2026-04-20T07:06:39.539Z",
        "updatedAt": "2026-04-20T07:06:39.539Z",
        "__v": 0
    },
    "break-in": {
        "record": [
            {
                "dateTime": "2026-04-21T07:58:56.153Z",
                "status": "time-in",
                "month": 4,
                "day": 21,
                "year": 2026,
                "time": 1776729536369,
                "date": "2026-04-21T00:00:00.000Z",
                "location": {
                    "latitude": 14.8778582,
                    "longitude": 121.0476633
                },
                "address": "N/A",
                "ip": "Test"
            },

        ],
        "_id": "69e6bdc07b564a0069b2c609",
        "uid": "61442a17a6566a001623bf20",
        "date": new Date().toISOString(),
        "status": "time-in",
        "createdAt": "2026-04-21T07:58:56.153Z",
        "updatedAt": "2026-04-21T07:58:56.153Z",
        "__v": 0
    },
    "break-out": {
        "record": [
            {
                "dateTime": "2026-04-21T07:58:56.153Z",
                "status": "time-in",
                "month": 4,
                "day": 21,
                "year": 2026,
                "time": 1776729536369,
                "date": "2026-04-21T00:00:00.000Z",
                "location": {
                    "latitude": 14.8778582,
                    "longitude": 121.0476633
                },
                "address": "N/A",
                "ip": "Test"
            },
            {
                "dateTime": "2026-04-21T08:42:53.486Z",
                "status": "break-in",
                "month": 4,
                "day": 21,
                "year": 2026,
                "time": 1776732173520,
                "date": "2026-04-21T00:00:00.000Z",
                "location": {
                    "latitude": 14.877841971169833,
                    "longitude": 121.04762329157752
                },
                "address": "N/A",
                "ip": "Test"
            }
        ],
        "_id": "69e6bdc07b564a0069b2c609",
        "uid": "61442a17a6566a001623bf20",
        "date": new Date().toISOString(),
        "status": "break-in",
        "createdAt": "2026-04-21T07:58:56.153Z",
        "updatedAt": "2026-04-21T00:42:53.891Z",
        "__v": 0
    },
    "time-out": {
        "record": [
            {
                "dateTime": "2026-04-21T11:08:39.163Z",
                "status": "time-in",
                "month": 4,
                "day": 21,
                "year": 2026,
                "time": 1776740919201,
                "date": "2026-04-21T00:00:00.000Z",
                "location": {
                    "latitude": 14.87778456153512,
                    "longitude": 121.04757919003877
                },
                "address": "N/A",
                "ip": "Test"
            }
        ],
        "_id": "69e6ea377b564a0069b62c58",
        "uid": "61442a17a6566a001623bf20",
        "date": new Date().toISOString(),
        "status": "time-in",
        "createdAt": "2026-04-21T11:08:39.163Z",
        "updatedAt": "2026-04-21T11:08:39.163Z",
        "__v": 0
    }
}

//compatible for user/status endpoints
let simulatedTimeRecords = {
    'none': [
        //value object that has time in and time out record from yesterday, and sztatus is timed out
        {
            "_id": "69e55fff7b564a00699d7993",
            "record": [
                {
                    "dateTime": "2026-04-20T07:06:39.539Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 20,
                    "year": 2026,
                    "time": 1776639999583,
                    "date": "2026-04-20T00:00:00.000Z",
                    "location": {
                        "latitude": 14.8779002,
                        "longitude": 121.0476598
                    },
                    "address": "N/A",
                    "ip": "Test"
                },
                {
                    "dateTime": "2026-04-20T07:06:39.539Z",
                    "status": "time-out",
                    "month": 4,
                    "day": 20,
                    "year": 2026,
                    "time": 1776639999583,
                    "date": "2026-04-20T00:00:00.000Z",
                    "location": {
                        "latitude": 14.8779002,
                        "longitude": 121.0476598
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "61442a17a6566a001623bf20",
            "date": getYesterdayDateISO(),
            "status": "time-out",
            "createdAt": "2026-04-20T07:06:39.539Z",
            "updatedAt": "2026-04-20T07:06:39.539Z",
            "__v": 0
        }
    ],
    'time-in': [

        {
            "_id": "69e55fff7b564a00699d7993",
            "record": [
                {
                    "dateTime": "2026-04-20T07:06:39.539Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 20,
                    "year": 2026,
                    "time": 1776639999583,
                    "date": "2026-04-20T00:00:00.000Z",
                    "location": {
                        "latitude": 14.8779002,
                        "longitude": 121.0476598
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "61442a17a6566a001623bf20",
            "date": new Date().toISOString(),
            "status": "time-in",
            "createdAt": "2026-04-20T07:06:39.539Z",
            "updatedAt": "2026-04-20T07:06:39.539Z",
            "__v": 0
        }
    ],
    'break-in': [{
        "record": [
            {
                "dateTime": "2026-04-20T07:06:39.539Z",
                "status": "time-in",
                "month": 4,
                "day": 20,
                "year": 2026,
                "time": 1776639999583,
                "date": "2026-04-20T00:00:00.000Z",
                "location": {
                    "latitude": 14.8779002,
                    "longitude": 121.0476598
                },
                "address": "breakout mock",
                "ip": "Test"
            },
            {
                "dateTime": "2026-04-20T15:30:23.472Z",
                "status": "break-in",
                "month": 4,
                "day": 20,
                "year": 2026,
                "time": 1776670223521,
                "date": "2026-04-20T00:00:00.000Z",
                "location": {
                    "latitude": 14.877804749942635,
                    "longitude": 121.04759280420946
                },
                "address": "N/A",
                "ip": "Test"
            },

        ],
        "_id": "69e55fff7b564a00699d7993",
        "uid": "61442a17a6566a001623bf20",
        "date": new Date().toISOString(),
        "status": "break-in",
        "createdAt": "2026-04-20T07:06:39.539Z",
        "updatedAt": "2026-04-20T07:33:03.570Z",
        "__v": 0
    }],
    'break-out': [{
        //the response format for break in is this
        /*
        time in 
        break in
        */
        "record": [
            {
                "dateTime": "2026-04-20T07:06:39.539Z",
                "status": "time-in",
                "month": 4,
                "day": 20,
                "year": 2026,
                "time": 1776639999583,
                "date": "2026-04-20T00:00:00.000Z",
                "location": {
                    "latitude": 14.8779002,
                    "longitude": 121.0476598
                },
                "address": "breakin mock",
                "ip": "Test"
            },
            {
                "dateTime": "2026-04-20T15:30:23.472Z",
                "status": "break-in",
                "month": 4,
                "day": 20,
                "year": 2026,
                "time": 1776670223521,
                "date": "2026-04-20T00:00:00.000Z",
                "location": {
                    "latitude": 14.877804749942635,
                    "longitude": 121.04759280420946
                },
                "address": "N/A",
                "ip": "Test"
            },
            {
                "dateTime": "2026-04-20T15:31:23.472Z",
                "status": "break-out",
                "month": 4,
                "day": 20,
                "year": 2026,
                "time": 1776670223521,
                "date": "2026-04-20T00:00:00.000Z",
                "location": {
                    "latitude": 14.877804749942635,
                    "longitude": 121.04759280420946
                },
                "address": "N/A",
                "ip": "Test"
            }

        ],
        "_id": "69e55fff7b564a00699d7993",
        "uid": "61442a17a6566a001623bf20",
        "date": new Date().toISOString(),
        "status": "break-out",
        "createdAt": "2026-04-20T07:06:39.539Z",
        "updatedAt": "2026-04-20T07:33:36.556Z",
        "__v": 0
    }],
    'time-out': [
        {
            "_id": "69e6ea377b564a0069b62c58",
            "record": [
                {
                    "dateTime": "2026-04-21T11:08:39.163Z",
                    "status": "time-in",
                    "month": 4,
                    "day": 21,
                    "year": 2026,
                    "time": 1776740919201,
                    "date": "2026-04-21T00:00:00.000Z",
                    "location": {
                        "latitude": 14.87778456153512,
                        "longitude": 121.04757919003877
                    },
                    "address": "N/A",
                    "ip": "Test"
                },
                {
                    "dateTime": "2026-04-21T11:09:17.117Z",
                    "status": "time-out",
                    "month": 4,
                    "day": 21,
                    "year": 2026,
                    "time": 1776740957151,
                    "date": "2026-04-21T00:00:00.000Z",
                    "location": {
                        "latitude": 14.877809386128035,
                        "longitude": 121.04750230603895
                    },
                    "address": "N/A",
                    "ip": "Test"
                }
            ],
            "uid": "61442a17a6566a001623bf20",
            "date": new Date().toISOString(),
            "status": "time-out",
            "createdAt": "2026-04-21T11:08:39.163Z",
            "updatedAt": "2026-04-21T03:09:17.530Z",
            "__v": 0
        }
    ]
}

class ShiftSimulation {

    //none, time-in, break-in, break-out, time-out 
    static status = 'none'
    static updateStatus(newStatus) {
        this.status = newStatus
    }

    //this is just getting current shift record for url /status
    static getTimeRecordByStatus() {
        console.log('getting records with this status', this.status)
        return simulatedTimeRecords[this.status]
    }

    //this is when we time in and time out for url/time
    static updateTimeRecord(status) {
        this.status = status
        return simulatedResponses[status]
    }

    static getSimulatedRecord() {
        return simulatedTimeRecords[status]
    }

    static getRecordByStatus(status) {
        return simulatedTimeRecords[status]
    }
}

export default ShiftSimulation
